//----- Component --------------------------------------------------------/
// Developer : IGNACIO BASTIANELLI
// Creation Date : 13/03/2025
// Version : 1
// Description : Configuracion de correos para enviar mails a medicos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import Navbar from "../../Navbar";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";
import AppBar from "@mui/material/AppBar";

import {
  Button,
  Box,
  Grid,
  Stack,
  Snackbar,
  TextField,
  Alert,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";

function Mails() {
  const [solicitudConfig_original, setSolicitudConfig_original] =
    useState(null);
  const [solicitudConfig, setSolicitudConfig] = useState([
    {
      mail: "",
    },
  ]);
  const [disGuardar, setDisGuardar] = useState(false);
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    logEventos(
      "Acceso al menú configuración mail-casos",
      "Solicitud de personal",
      "Cambiar donde envia el mail la solicitud",
      localStorage.getItem("user")
    );
  }, []);

  const getConfig = () => {
    fetch(UrlApi + "/SP_mails")
      .then((data) => data.json())
      .then((data) => {
        setSolicitudConfig(data[0]); // Inicio los datos de solicitudConfig como me los traigo de la bd
        setSolicitudConfig_original(data[0]); //Guardo la configuración original para luego compararla y ver si hay modificaciones.
      });
  };

  useEffect(() => {
    getConfig();
  }, []);

  const almacenar = (e) => {
    setSolicitudConfig({ ...solicitudConfig, [e.target.name]: e.target.value });
  };

  const guardarConfig = async (e) => {
    logEventos(
      "Guardar Email",
      "Configuración mail - medicos",
      "Se guardo la configuración del mail",
      localStorage.getItem("user")
    );
    e.preventDefault();
    await fetch(UrlApi + "/SP_mails", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mail: solicitudConfig.mail,
        user: localStorage.getItem("user"),
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La configuración se guardó exitosamente !");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar la configuración");
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  return (
    <div>
      <Navbar />
      <Container maxWidth="lg">
        <AppBar
          position="static"
          sx={{ backgroundColor: "#2B76A6", width: "100%", marginTop: 2 }}
        >
          <Toolbar>
            <Typography
              variant="h5"
              sx={{ textAlign: "center", margin: "auto", width: "100%" }}
            >
              Configuración de Mail - Medico
            </Typography>
          </Toolbar>
        </AppBar>
        {/* <Title
          titulo={"Configuración de mail"}
        /> */}
        <form onSubmit={guardarConfig}>
          <Box
            my={1}
            backgroundColor="#F4F6F6"
            p={2}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="mail"
                  label="Mail"
                  value={solicitudConfig.mail}
                  onChange={almacenar}
                  // style={{ backgroundColor: "#fff"}}
                  focused
                  color="primary"
                  type="mail"
                  inputProps={{ maxLength: 500 }}
                  helperText={`Para añadir más de un correo, sepárelos con ; (punto y coma). ${
                    solicitudConfig.mail.length || 0
                  }/500 caracteres`}
                  style={{
                    width: "270%",
                    marginBottom: "10px",
                    backgroundColor: "#fff",
                  }}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="success"
                  type="submit"
                  disabled={disGuardar}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Container>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
}

export default Mails;
